const certificates = {
  pm: {
    name: 'Product Management Interview Course',
    description: 'As a candidate, you’ve shown a strong understanding of these concepts in your product management interviews:',
    objectives: [
      {
        name: 'Analytics',
        description:
            'You make decisions based on user metrics, feedback, and adoption rates. You think critically about how product changes affect users.',
        icon: 'CalculatorIcon',
      },
      {
        name: 'Execution',
        description:
            'You use data to solve problems and address user pain points. You can set actionable KPIs for product development and user satisfaction.',
        icon: 'PlayIcon',
      },
      {
        name: 'Technical Product Management',
        description:
            'You demonstrate a clear understanding of how technical constraints affect product development and software teams.',
        icon: 'DesktopComputerIcon',
      },
      {
        name: 'Product Design',
        description:
            'You balance creativity and user-centric design to deliver industry-leading products that align with a company’s product vision.',
        icon: 'BeakerIcon',
      },
      {
        name: 'Product Strategy',
        description:
            'You can perform competitive market analysis to create product roadmaps that amplify the efforts of a business.',
        icon: 'PresentationChartLineIcon',
      },
      {
        name: 'Estimation',
        description:
            'Operating on your assumptions is second nature. You can quickly estimate the impacts of your product work with incomplete data.',
        icon: 'QuestionMarkCircleIcon',
      },
    ],
  },
  'software-engineering': {
    name: 'Software Engineering Interview Course',
    description: 'As a candidate, you’ve shown a strong understanding of these concepts in your software engineering interviews:',
    objectives: [
      {
        name: 'Data Structures and Algorithms',
        description:
            'You build quality code by employing optimal data structures and algorithms.',
        icon: 'CodeIcon',
      },
      {
        name: 'Technical Skills',
        description:
            'You solve complex problems with ease. You build on your experience as an engineer to scope out and address new challenges.',
        icon: 'ClipboardCheckIcon',
      },
      {
        name: 'System Design',
        description:
            'You build reliable, scalable, and maintainable systems. You make strategic decisions from the component level to the system level.',
        icon: 'DatabaseIcon',
      },
      {
        name: 'Teamwork',
        description:
            'Your team and organization work more efficiently because of you. Your insights and guidance make you a valuable teammate.',
        icon: 'UserGroupIcon',
      },
    ],
  },
  'engineering-management': {
    name: 'Engineering Management Interview Course',
    description: 'As a candidate, you’ve shown a strong understanding of these concepts in your engineering management interviews:',
    objectives: [
      {
        name: 'People Management',
        description:
            'You demonstrate strong leadership and provide guidance to action-oriented teams. You’re collaborative and are an excellent example of your company’s values.',
        icon: 'UserGroupIcon',
      },
      {
        name: 'Project Management',
        description:
            'You plan and deliver complex engineering projects. Other engineers and stakeholders look to you for knowledge of projects and timelines.',
        icon: 'ClipboardListIcon',
      },
      {
        name: 'System Design',
        description:
            'You build reliable, scalable, and maintainable systems. You make strategic decisions from the component level to the system level.',
        icon: 'DatabaseIcon',
      },
    ],
  },
  tpm: {
    name: 'Technical Product Management Interview Course',
    description: 'As a candidate, you’ve shown a strong understanding of these concepts in your technical product management interviews:',
    objectives: [
      {
        name: 'System Design',
        description:
            'You build reliable, scalable, and maintainable systems. You make strategic decisions from the component level to the system level.',
        icon: 'DatabaseIcon',
      },
      {
        name: 'Program Management',
        description:
            'You empathize with and understand your teammate’s bottlenecks. You improve technical processes to make your team more efficient.',
        icon: 'ChartSquareBarIcon',
      },
      {
        name: 'Inter-team management',
        description:
            'You reliably ship products and improve communication between cross-functional teams.',
        icon: 'UsersIcon',
      },
    ],
  },
};

export default certificates;
